import { useFormik, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { getNationlityList, getNationlityListCancelToken } from "../../../../services/RegistrationService";
import RenderPreviousValues from "./RenderPreviousValues";
import axios from "axios";
import TextInput from "../../../../components/library/TextInput";
import SelectDropdown from "../../../../components/library/SelectDropdown";
import Button from "../../../../components/library/Button";
import { tokens } from "../../../../public/tokens";

// Styled component for spacing
const FormField = styled.div`
  margin-bottom: 24px;
`;

function Address(props) {

  const [disabled, setDisabled] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [province, setProvince] = useState([]);
  const [country, setCountry] = useState([]);
  const [studentData, setStudentData] = useState();
  const [dropdownValues, setDropdownValues] = useState(useSelector((state) => state.registerDropdownValues));

  const fixDataFormet = (obj) => {
    let tempArr = [];
    obj.map((item) => {
      tempArr.push({ value: item.crm_country_slug ? item.crm_country_slug : item.country_code, label: item.country });
    });
    return tempArr;
  };
  useEffect(() => {
    setStudentData(props.studentData);
    setProvince(dropdownValues.province)
  }, [props]);

  useEffect(() => {
    const cancelTokenSources = [];
    const getData = async () => {

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        const res = await getNationlityListCancelToken(source.token)
        if (res.status === 200) {
          setCountry(fixDataFormet(res.data.data));
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }

    getData();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [])

  const handleSameAsHome = async () => {
    await formik.setFieldValue("PostalStreetAddress", formik.values.StreetAddress);
    await formik.setFieldValue("PostalCity", formik.values.City);
    await formik.setFieldValue("PostalProvince", formik.values.Province);
    await formik.setFieldValue("PostalCountry", formik.values.Country);
    await formik.setFieldValue("PostalCodePostal", formik.values.PostalCode);
  };

  const formik = useFormikContext();

  const getError = (field) => {
    return formik.errors[field] && formik.touched[field] ? formik.errors[field] : "";
  };
  const showError = (field) => Boolean(formik.errors[field] && formik.touched[field]);

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="edit-icon new-card-header">
        <div className="card-header">Address</div>
      </div>
      <div className="edit-icon new-card-header">
        <div className="card-subheading">Home</div>
      </div>
      {/* <form onSubmit={formik.handleSubmit}></form> */}
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <FormField>
              <TextInput
                id="StreetAddress"
                label="Street Address"
                name="StreetAddress"
                value={formik.values.StreetAddress || ""}
                placeholder="Enter Street Address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={150}
                error={showError("StreetAddress")}
                errorText={getError("StreetAddress")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_street} previousValue={studentData?.RegStudentsPreviousDetails?.ph_street} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <TextInput
                id="City"
                label="City"
                name="City"
                value={formik.values.City || ""}
                placeholder="Enter City"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={showError("City")}
                errorText={getError("City")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_city} previousValue={studentData?.RegStudentsPreviousDetails?.ph_city} typeSupportingProps={{
              from: "city"
            }} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <SelectDropdown
                id="Province"
                label="Province"
                name="Province"
                options={province.map(item => ({ value: item.value, label: item.label }))}
                value={formik.values.Province || ""}
                onChange={(event) => {
                  formik.setFieldValue("Province", event.target.value);
                }}
                onBlur={formik.handleBlur}
                placeholder={formik.values.Province ? formik.values.Province : "Select"}
                error={showError("Province")}
                errorText={getError("Province")}
                isClearable
                onClear={() => formik.setFieldValue("Province", "")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_province} previousValue={studentData?.RegStudentsPreviousDetails?.ph_province} type="dropdown" typeSupportingProps={{filterArray : province}} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <SelectDropdown
                id="Country"
                label="Country"
                name="Country"
                options={country.map(item => ({ value: item.value, label: item.label }))}
                value={formik.values.Country || ""}
                onChange={(event) => {
                  formik.setFieldValue("Country", event.target.value);
                }}
                onBlur={formik.handleBlur}
                placeholder={formik.values.Country ? formik.values.Country : "Select"}
                error={showError("Country")}
                errorText={getError("Country")}
                isClearable
                onClear={() => formik.setFieldValue("Country", "")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_country} previousValue={studentData?.RegStudentsPreviousDetails?.ph_country} type="dropdown" typeSupportingProps={{filterArray : country}} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <TextInput
                id="PostalCode"
                label="Postal Code"
                name="PostalCode"
                value={formik.values.PostalCode || ""}
                placeholder="Enter Postal Code"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={10}
                error={showError("PostalCode")}
                errorText={getError("PostalCode")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_zip} previousValue={studentData?.RegStudentsPreviousDetails?.ph_zip} />
          </div>
          {props.invoiceData && (
          <>
          <div className="col-md-6 col-lg-4">
            <b className="matched-purple">Latest Invoice:</b><br/>
            <b>Billing Address:</b> {props.invoiceData.billingAddress || "-"}<br/>
          </div>
          </>
        )}
        </div>
        <div className="edit-icon new-card-header d-flex">
          <div className="card-subheading">Shipping Address</div>
        </div>

          <div className="row">
            <div className="col-md-4 mb-3">
              <Button
                type="button"
                onClick={() => handleSameAsHome()}
                variant="primary"
                size="md"
              >
                <i className="fal fa-copy"></i>
                Same As Home
              </Button>
          </div>
        </div>
        
        {/* <div className="row">
          <div className="col-md-4">
            <div className="form-group-blk mb-3">
              <div className="form-group form-group-save-cancel">

              </div>
            </div>
          </div>
        </div> */}
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <FormField>
              <TextInput
                id="PostalStreetAddress"
                label="Street Address"
                name="PostalStreetAddress"
                value={formik.values.PostalStreetAddress || ""}
                placeholder="Enter Street Address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={150}
                error={showError("PostalStreetAddress")}
                errorText={getError("PostalStreetAddress")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_street_postal} previousValue={studentData?.RegStudentsPreviousDetails?.ph_street_postal} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <TextInput
                id="PostalCity"
                label="City"
                name="PostalCity"
                value={formik.values.PostalCity || ""}
                placeholder="Enter Postal City"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={showError("PostalCity")}
                errorText={getError("PostalCity")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_city_postal} previousValue={studentData?.RegStudentsPreviousDetails?.ph_city_postal} typeSupportingProps={{from: "phCity"}} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <SelectDropdown
                id="PostalProvince"
                label="Province"
                name="PostalProvince"
                options={province.map(item => ({ value: item.value, label: item.label }))}
                value={formik.values.PostalProvince || ""}
                onChange={(event) => {
                  formik.setFieldValue("PostalProvince", event.target.value);
                }}
                onBlur={formik.handleBlur}
                placeholder={formik.values.PostalProvince ? formik.values.PostalProvince : "Select"}
                error={showError("PostalProvince")}
                errorText={getError("PostalProvince")}
                isClearable
                onClear={() => formik.setFieldValue("PostalProvince", "")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_province_postal} previousValue={studentData?.RegStudentsPreviousDetails?.ph_province_postal} type="dropdown" typeSupportingProps={{filterArray : province}} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <SelectDropdown
                id="PostalCountry"
                label="Country"
                name="PostalCountry"
                options={country.map(item => ({ value: item.value, label: item.label }))}
                value={formik.values.PostalCountry || ""}
                onChange={(event) => {
                  formik.setFieldValue("PostalCountry", event.target.value);
                }}
                onBlur={formik.handleBlur}
                placeholder={formik.values.PostalCountry ? formik.values.PostalCountry : "Select Country"}
                error={showError("PostalCountry")}
                errorText={getError("PostalCountry")}
                isClearable
                onClear={() => formik.setFieldValue("PostalCountry", "")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_country_postal} previousValue={studentData?.RegStudentsPreviousDetails?.ph_country_postal} type="dropdown" typeSupportingProps={{filterArray : country}} />
          </div>
          <div className="col-md-6 col-lg-4">
            <FormField>
              <TextInput
                id="PostalCodePostal"
                label="Postal Code"
                name="PostalCodePostal"
                value={formik.values.PostalCodePostal || ""}
                placeholder="Enter Postal Code"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={10}
                error={showError("PostalCodePostal")}
                errorText={getError("PostalCodePostal")}
              />
            </FormField>
            <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.ph_zip_postal} previousValue={studentData?.RegStudentsPreviousDetails?.ph_zip_postal} />
          </div>
          {props.invoiceData && (
          <>
          <div className="col-md-6 col-lg-4">
            <b className="matched-purple">Latest Invoice:</b><br/>
            <b>Shipping Address:</b> {props.invoiceData.shippingAddress || "-"}<br/>
          </div>
          </>
        )}
        </div>
      <hr />
    </div>
  );
}

export default Address;
